import React from "react";
import { useInternalModel } from "../internalModel";

import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";

const searchFields = [
    {
        type: SearchTypeEnum.Input,
        placeholder: "文章标题",
        fieldName: "title"
    },
    {
        type: SearchTypeEnum.Input,
        placeholder: "创建人",
        fieldName: "createUser"
    },
    {
        type: SearchTypeEnum.Datepicker,
        fieldName: "createTime",
        placeholder: "创建时间",
        format: "YYYY-MM-DD",
    },
]

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useInternalModel();

    return (
        <YhPageHeader
            title="国内案例"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => loadData(initPgCfg, {...searchParam,...params})}
            handleReset={resetSearchParam}
        />
    );
}